import FootballState from "../../../../state/football-state";
import RushStats from "../../../offensive/rush/rush-stats";

export default class FieldGoalFakeRunStats extends RushStats {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalFakeRun;
    }
}
